export const isSafariBrowser = () => {
  const ua = navigator.userAgent;
  return /Safari/i.test(ua) && !/Chrome|CriOS|Android/i.test(ua);
};

export const createMSESource = async url => {
  const mime = 'audio/ogg; codecs="opus"';
  if (!window.MediaSource || !MediaSource.isTypeSupported(mime)) {
    return url;
  }

  const response = await fetch(url);
  const buffer = await response.arrayBuffer();

  return new Promise(resolve => {
    const mediaSource = new MediaSource();
    const objectUrl = URL.createObjectURL(mediaSource);
    mediaSource.addEventListener('sourceopen', () => {
      const sourceBuffer = mediaSource.addSourceBuffer(mime);
      sourceBuffer.addEventListener('updateend', () => {
        mediaSource.endOfStream();
        resolve(objectUrl);
      });
      sourceBuffer.appendBuffer(buffer);
    });
  });
};
